import {neverHappensSilent} from '@shared/lib/utils/type_utils';

import {CompressedScraperItemsApi, DbDataState} from '@website_frontend/lib/db_cache';

export function getStateMessage(
  state: DbDataState,
  data: CompressedScraperItemsApi | undefined
): string {
  switch (state.type) {
    case 'idle':
      return '';
    case 'checking_cache':
      return 'Vérification du cache...';
    case 'fetching_urls':
      return 'Récupération des URLs...';
    case 'loading_from_cache':
      return 'Chargement depuis le cache...';
    case 'fetching_parts':
      return state.progress !== undefined && state.total !== undefined
        ? `Récupération des données compressées (${state.progress}/${state.total})...`
        : 'Récupération des données compressées...';
    case 'reassembling':
      return 'Réassemblage des données...';
    case 'saving_cache':
      return 'Sauvegarde dans le cache...';
    case 'decompressing':
      return 'Décompression des données...';
    case 'success':
      return `${data?.length?.toLocaleString()} annonces`;
    case 'error':
      return `Erreur : ${state.error.message}`;
  }
  neverHappensSilent(state);
  return (state as DbDataState).type;
}
